import { createSlice } from "@reduxjs/toolkit";
// utils
import { PATH_DASHBOARD } from "../../routes/paths";
import axios from "../../utils/axios";
import { postTags, updateTags } from "./tags";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  features: [],
  singleFeature: {},
  fetchLoading: false,
};

const slice = createSlice({
  name: "features",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // FETCH  LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },

    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.fetchLoading = false;
    },

    // TODO: success post blog

    postFeatureSuccess(state, action) {
      state.isLoading = false;
      // state.features = [action.payload, ...state.features.data];
      // state.features.meta.total += 1;
    },
    // TODO: successFetch blog

    getFeatureSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.features = action.payload;
    },

    // TODO: single blog fetch success

    getSingleFeatureSucess(state, action) {
      state.isLoading = false;
      state.singleFeature = action.payload;
    },

    // Update blog
    updateFeatureSuccess(state, action) {
      state.isLoading = false;
      // state.features.data = state.features.data.map((feature) => {
      //   if (feature.slug === action.payload.slug) {
      //     return action.payload;
      //   } else {
      //     return feature;
      //   }
      // });
    },

    // delete blog
    deleteFeatureSuccess(state, action) {
      state.isLoading = false;
      // state.features.data = state.features.data.filter(
      //   (feature) => feature.id !== action.payload
      // );
      // state.features.meta.total -= 1;
    },
  },
});

export default slice.reducer;

export function getFeatures({ categoryId, limit = 5, page = 0, season_id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`items`, {
        params: {
          limit,
          page: page + 1,
          category_slug: categoryId,
          season_id,
        },
      });

      dispatch(
        slice.actions.getFeatureSuccess({
          data: response.data.data.data,
          meta: {
            total: response.data.data.total,
          },
        })
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateFeature({
  slug,
  data,
  tagData,
  enqueueSnackbar,
  tag_id,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`items/${slug}`, data);
      if (
        tagData?.team ||
        tagData?.player ||
        tagData?.game ||
        tagData?.category
      ) {
        if (tag_id) {
          dispatch(
            updateTags({
              tagData: { ...tagData, item_id: response.data.data.id },
              enqueueSnackbar,
              tag_id,
            })
          );
        } else {
          dispatch(
            postTags({
              tagData: { ...tagData, item_id: response.data.data.id },
              enqueueSnackbar,
            })
          );
        }
      }

      dispatch(slice.actions.updateFeatureSuccess(response.data.data));
      enqueueSnackbar("Feature is updated successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function postFeature({ data, enqueueSnackbar, tagData, navigate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`items`, data);

      dispatch(
        postTags({
          tagData: { ...tagData, item_id: response.data.data.id },
          enqueueSnackbar,
        })
      );

      dispatch(
        postTags({
          tagData: { ...tagData, item_id: response.data.data.id },
          enqueueSnackbar,
        })
      );
      dispatch(slice.actions.postFeatureSuccess(response.data.data));
      enqueueSnackbar("Feature is created successfully");
      navigate(PATH_DASHBOARD.feature.list);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFeature(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`items/${id}`);

      dispatch(slice.actions.getSingleFeatureSucess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteFeature({
  id,
  enqueueSnackbar,
  categoryId,
  pagination,
  season_id,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`items/${id}`);
      dispatch(slice.actions.deleteFeatureSuccess(id));
      dispatch(
        getFeatures({
          categoryId,
          page: pagination.page,
          limit: pagination.limit,
          season_id,
        })
      );
      enqueueSnackbar("Feature is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}
